import { IRetryPolicy } from '@microsoft/signalr';

export interface ISignalRRetryPolicy extends IRetryPolicy {

}